/* eslint-disable */
import { gsap } from "gsap/all";

// const $footerLinks = document.querySelectorAll(".js-link a");
const $footerLinks = document.querySelectorAll(".page-footer .footer-menu a");

for (var i = 0; i < $footerLinks.length; i++) {
  $footerLinks[i].addEventListener('click' , (event, target) => {
    event.preventDefault();
    // console.log(event);

    if( event.target.href == window.location.href ) return;

    gsap.to( '#bgFadeIn' , 0.4 , {
      opacity: 0,
      ease: 'power1.in'
    })

    gsap.to( '.app-wrapper' , 0.5 , {
      opacity: 0,
      ease: 'power1.in',
    })

    setTimeout(()=>{
      window.location.href = event.target.href;
    } , 750);

  })
}



// WEBPACK FOOTER //
// ./scripts/js/links.js